import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin } from 'lucide-react';
export function ContactSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-17">
      <div className="container mx-auto px-4" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-19">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-20">
            Kontaktirajte nas
          </h2>
          <p className="text-lg text-slate-600" data-id="element-21">
            Radi vam bomo pomagali pri vseh vprašanjih
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-5xl mx-auto" data-id="element-22">
          <div className="bg-slate-50 rounded-xl p-6 md:p-8 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-23">
            <div className="flex items-start gap-4" data-id="element-24">
              <div className="w-12 h-12 bg-[#1EB6E8]/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-25">
                <Phone className="w-6 h-6 text-[#1EB6E8]" data-id="element-26" />
              </div>
              <div data-id="element-27">
                <h3 className="font-semibold text-slate-900 mb-1" data-id="element-28">Telefon</h3>
                <a href="tel:+38631302033" className="text-slate-600 hover:text-[#1EB6E8] transition-colors" data-id="element-29">
                  +386 31 302 033
                </a>
                <p className="text-sm text-slate-500 mt-1" data-id="element-30">
                  Pon - Pet: 9:00 - 17:00
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-31">
              <div className="w-12 h-12 bg-[#1EB6E8]/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-32">
                <Mail className="w-6 h-6 text-[#1EB6E8]" data-id="element-33" />
              </div>
              <div data-id="element-34">
                <h3 className="font-semibold text-slate-900 mb-1" data-id="element-35">E-pošta</h3>
                <a href="mailto:info@autopoint.si" className="text-slate-600 hover:text-[#1EB6E8] transition-colors" data-id="element-36">
                  info@autopoint.si
                </a>
                <p className="text-sm text-slate-500 mt-1" data-id="element-37">
                  Odgovorimo v 24 urah
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-38">
              <div className="w-12 h-12 bg-[#1EB6E8]/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-39">
                <MapPin className="w-6 h-6 text-[#1EB6E8]" data-id="element-40" />
              </div>
              <div data-id="element-41">
                <h3 className="font-semibold text-slate-900 mb-1" data-id="element-42">Naslov</h3>
                <p className="text-slate-600" data-id="element-43">
                  Dunajska cesta 123
                  <br data-id="element-44" />
                  1000 Ljubljana
                  <br data-id="element-45" />
                  Slovenija
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}